import { Component } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { URL_PARAMS } from "./constants";
import { AuthService } from "./services/auth.service";
import { ActivatedRoute } from "@angular/router";
import { UtilityService } from "./services/utility.service";
import { SessionService } from "./services/session.service";
import { Maintenance, MaintenanceService } from "./services/maintenance.service";
import { formatDate } from "@angular/common";
import { I18nService } from "./services/i18n.service";

@Component( {
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: [ "./app.component.scss" ]
} )

export class AppComponent {
	title = "platform";
	token: string;
	underMaintenance: boolean = false;
	currentMaintenance: Maintenance;
	maintenanceInterval;
	timezone: string;
	locale = 'de';

	constructor(
		private authService: AuthService,
		private spinnerService: NgxSpinnerService,
		private i18nService: I18nService,
		private activatedRoute: ActivatedRoute,
		private utilityService: UtilityService,
		private sessionService: SessionService,
		private maintenanceService: MaintenanceService
	) {

		const storedLanguage = this.sessionService.language;
		this.i18nService.switchLanguage(storedLanguage);
		this.i18nService.currentLanguage.subscribe(lang => {
			this.locale = lang;
		});

		this.timezone = formatDate(new Date(), 'Z', 'de');

		if( this.isAccountActivation( window.location.href ) ) {
			this.utilityService.clearStorageAndCookies();
			return;
		}
		this.maintenanceService.nextMaintenance$.subscribe((maintenance) => {
			if (maintenance === null || !maintenance.lockPage) {
				if (this.underMaintenance) {
					clearInterval(this.maintenanceInterval);
					this.currentMaintenance = null;
					this.underMaintenance = false;
				}
				return;
			} else {
				const start = new Date(maintenance.start);
				const end = new Date(maintenance.end);
				const now = new Date();
				if (!this.underMaintenance && (start < now && end > now)) {
					this.underMaintenance = true;
					this.currentMaintenance = maintenance;
					this.maintenanceInterval = setInterval(() => {
						this.maintenanceService.loadNextMaintenance();
					}, 20 * 1000);
				} else if (this.underMaintenance && !(start < now && end > now)) {
					clearInterval(this.maintenanceInterval);
					this.currentMaintenance = null;
					this.underMaintenance = false;
				}
			}
		});
		this.maintenanceService.loadNextMaintenance();
	}

	off() {
		this.underMaintenance = false;
	}

	changeLanguage(language: string): void {
		this.i18nService.switchLanguage(language);
	}

	/**
	 * Check for account activation url
	 * @param url: current url from browser
	 */
	isAccountActivation( url: string ): boolean {
		const queryParams = this.utilityService.getParamsFromEncodedUrl( url );
		if( queryParams && queryParams[URL_PARAMS.EMAIL] && queryParams[URL_PARAMS.TYPE] && queryParams[URL_PARAMS.TYPE] ) {
			return true;
		}
		return false;
	}
}
